import React from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import DesignCloud from "./routes/DesignCloud";
import OrderForm from "./routes/OrderForm";

const ALLOWED_ORDER_FORM_HOSTNAMES = ["lysaght.com", "localhost"];

const App = () => (
    <Router>
        <Switch>
            <Route exact path="/">
                <Redirect to="/app" />
            </Route>
            <Route path="/app" component={DesignCloud} />
            <Route
                path="/carportorderform"
                render={() =>
                    ALLOWED_ORDER_FORM_HOSTNAMES.some(
                        (allowed) =>
                            window.location.hostname === allowed || window.location.hostname.endsWith(`.${allowed}`)
                    ) ? (
                        <OrderForm />
                    ) : (
                        <Redirect to="/app" />
                    )
                }
            />
        </Switch>
    </Router>
);

export default App;
